// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"1b4dea36","543":"1b4dea36","714":"1b4dea36"}[chunkId] + ".chunk.css";
};